(function () {
  function firstInvalid(step) {
    var fields = step.querySelectorAll('input, select, textarea');
    for (var index = 0; index < fields.length; index += 1) {
      if (!fields[index].checkValidity()) return fields[index];
    }
    return null;
  }

  function initAtelier(root) {
    if (!root || root.dataset.csAtelierBound === 'true') return;
    var form = root.querySelector('.cs-atelier__form');
    if (!form) return;
    var steps = Array.prototype.slice.call(form.querySelectorAll('[data-step]'));
    var next = form.querySelector('[data-next]');
    var previous = form.querySelector('[data-prev]');
    var submit = form.querySelector('[data-submit]');
    var currentLabel = form.querySelector('[data-current-step]');
    var progressBar = form.querySelector('.cs-atelier__progress-bar span');
    if (!steps.length || !next || !previous || !submit) return;
    var current = 0;
    root.dataset.csAtelierBound = 'true';

    function showStep(stepIndex, shouldScroll) {
      current = Math.max(0, Math.min(stepIndex, steps.length - 1));
      steps.forEach(function (step, index) {
        var active = index === current;
        step.classList.toggle('is-active', active);
        step.hidden = !active;
        step.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      if (currentLabel) currentLabel.textContent = String(current + 1);
      if (progressBar) progressBar.style.width = String(((current + 1) / steps.length) * 100) + '%';
      previous.hidden = current === 0;
      next.hidden = current === steps.length - 1;
      submit.hidden = current !== steps.length - 1;
      if (shouldScroll) form.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    next.addEventListener('click', function (event) {
      event.preventDefault();
      var invalid = firstInvalid(steps[current]);
      if (invalid) {
        invalid.reportValidity();
        invalid.focus();
        return;
      }
      showStep(current + 1, true);
    });

    previous.addEventListener('click', function (event) {
      event.preventDefault();
      showStep(current - 1, true);
    });

    form.addEventListener('submit', function (event) {
      for (var index = 0; index < steps.length; index += 1) {
        var invalid = firstInvalid(steps[index]);
        if (invalid) {
          event.preventDefault();
          showStep(index, true);
          window.setTimeout(function () {
            invalid.reportValidity();
            invalid.focus();
          }, 250);
          return;
        }
      }
      submit.disabled = true;
      submit.textContent = 'Submitting…';
    });

    showStep(0, false);
  }

  function termsElements(checkboxId, buttonId, errorId) {
    return {
      checkbox: document.getElementById(checkboxId),
      button: document.getElementById(buttonId),
      error: document.getElementById(errorId)
    };
  }

  function renderTermsState(elements, saving) {
    if (!elements.checkbox || !elements.button) return;
    elements.button.disabled = saving || !elements.checkbox.checked;
    var drawerPayments = document.querySelector('[data-drawer-additional-checkout]');
    if (drawerPayments) drawerPayments.hidden = saving || !elements.checkbox.checked;
    var wrapper = elements.checkbox.closest('[data-terms-consent], .cs-drawer-terms');
    if (wrapper) {
      wrapper.classList.toggle('is-saving', saving);
      wrapper.classList.toggle('is-error', Boolean(elements.error && !elements.error.hidden));
    }
  }

  async function saveTerms(checkboxId, buttonId, errorId) {
    var elements = termsElements(checkboxId, buttonId, errorId);
    if (!elements.checkbox || !elements.button) return false;
    if (elements.error) elements.error.hidden = true;
    renderTermsState(elements, true);
    try {
      var response = await fetch(window.routes && window.routes.cart_update_url ? window.routes.cart_update_url : '/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          attributes: {
            'Terms & Conditions Accepted': elements.checkbox.checked ? 'Yes' : '',
            'Terms Version': elements.checkbox.checked ? '2026-09-08' : ''
          }
        })
      });
      if (!response.ok) throw new Error('Unable to save terms acceptance');
      elements.checkbox.dataset.termsSaved = elements.checkbox.checked ? 'yes' : 'no';
      renderTermsState(elements, false);
      return elements.checkbox.checked;
    } catch (error) {
      elements.checkbox.checked = false;
      elements.checkbox.dataset.termsSaved = 'no';
      if (elements.error) {
        elements.error.textContent = 'We could not save your acceptance. Please try again.';
        elements.error.hidden = false;
      }
      renderTermsState(elements, false);
      return false;
    }
  }

  window.CrestaStrandTerms = {
    update: function (checkbox, buttonId, errorId) {
      return saveTerms(checkbox.id, buttonId, errorId);
    },
    checkout: function (event, button, checkboxId, errorId) {
      var checkbox = document.getElementById(checkboxId);
      var error = document.getElementById(errorId);
      if (!checkbox || !checkbox.checked || checkbox.dataset.termsSaved !== 'yes') {
        event.preventDefault();
        if (error) {
          error.textContent = 'Please accept the Terms & Conditions to continue.';
          error.hidden = false;
        }
        if (checkbox) checkbox.focus();
        return false;
      }
      if (button.type === 'button') {
        event.preventDefault();
        window.location.assign(button.dataset.href || '/checkout');
        return false;
      }
      return true;
    }
  };

  function initTerms() {
    [
      ['cart_terms_accepted', 'cart-checkout', 'cart-terms-error'],
      ['sidebar_cart_conditions', 'cart-sidebar-checkout', 'drawer-terms-error']
    ].forEach(function (ids) {
      var elements = termsElements(ids[0], ids[1], ids[2]);
      if (!elements.checkbox || !elements.button) return;
      elements.checkbox.dataset.termsSaved = elements.checkbox.checked ? 'yes' : 'no';
      renderTermsState(elements, false);
    });
  }

  function initAll(scope) {
    var context = scope && scope.querySelectorAll ? scope : document;
    if (context.matches && context.matches('[id^="BespokeAtelier-"]')) initAtelier(context);
    Array.prototype.forEach.call(context.querySelectorAll('[id^="BespokeAtelier-"]'), initAtelier);
    initTerms();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); }, { once: true });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
  new MutationObserver(function () { initAll(document); }).observe(document.documentElement, { childList: true, subtree: true });
}());
